// examService.js

import axios from "axios";

export const finishExamOnLogout = async (courseId, userToken) => {
  try {
    // Submit exam (API will handle last answer if needed)
    await axios.get(`${process.env.REACT_APP_API_BASE_URL}/finish-course-exam/${courseId}`, {
      headers: { Accept: "application/json", Authorization: `Bearer ${userToken}` },
    });

    await axios.get(`${process.env.REACT_APP_API_BASE_URL}/retake-exam/${courseId}`, {
      headers: { Accept: "application/json", Authorization: `Bearer ${userToken}` },
    });

    // Clear localStorage related to exam
    localStorage.removeItem(`exam_timer_${courseId}`);
    localStorage.removeItem(`exam_started_${courseId}`);
  } catch (err) {
    console.error("Failed to finish exam on logout", err.response?.data || err);
  }
};
